import SafeImage from '@/components/SafeImage';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-foreground-900 to-foreground-800 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <h2 className="text-xl md:text-2xl font-heading text-background-50 mb-3">
                移动端体验
              </h2>
              <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-6 md:mb-8">
                牛牛影视移动版专为手机追剧优化，支持横竖屏自动切换、手势控制亮度与音量、后台缓存播放。无论通勤路上还是睡前时光，随时随地享受牛牛超清不缓冲的观影体验。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto px-7 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-all duration-200 text-center"
                >
                  iOS 版下载
                </a>
                <a
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full sm:w-auto px-7 py-3 rounded-full border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-200 text-center"
                >
                  Android 版下载
                </a>
              </div>
              <p className="text-xs text-background-50/40 mt-4">
                也支持浏览器直接访问，无需下载即可观影
              </p>
            </div>
            <div className="w-full lg:w-[280px] shrink-0 flex justify-center pb-6 lg:pb-0 lg:pr-8">
              <div className="relative w-44 md:w-52 aspect-[9/19] rounded-[2rem] border-4 border-background-50/20 overflow-hidden">
                <SafeImage
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20clean%20movie%20streaming%20app%20interface%20with%20dark%20theme%2C%20movie%20poster%20thumbnails%20in%20a%20grid%20layout%2C%20warm%20amber%20accent%20colors%20on%20selected%20items%2C%20minimalist%20UI%20design%2C%20elegant%20typography%2C%20premium%20app%20aesthetic%2C%20no%20real%20brand%20logos&width=520&height=1100&seq=app-mockup-2026-n1&orientation=portrait"
                  alt="牛牛影视移动端界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}